import { render, staticRenderFns } from "./co-signer.vue?vue&type=template&id=244e5352&"
import script from "./co-signer.vue?vue&type=script&lang=ts&"
export * from "./co-signer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports